module.exports = __webpack_public_path__ + "img/VeritasFront-Liners_7-12-2019.86edefd4.jpg";